import React, {ReactNode} from 'react';

import {PageProps, SupportedLanguage} from '../types';
import Header from './header';
import Footer from './footer';

import '../styles/layout.css';

interface LayoutProps {
	title: string;
	lang: SupportedLanguage;
	children: ReactNode;
}

type Props = PageProps & LayoutProps;
function Layout({location, title, lang, children}: Props) {
	return (
		<div className="Layout">
			<Header location={location} title={title} lang={lang} />

			<main>{children}</main>

			<Footer lang={lang} />
		</div>
	);
}

export default Layout;
